import React from 'react';
import { Card } from '@material-ui/core';
import _ from 'lodash';
import * as RegistrationReceivedSelector from 'redux/reducers/registration_received_reducer/selectors';
import useStyles from './styles';
import * as DatesUtils from 'utils/dates';

function addhttps(url: string) {
  if (!/^(?:f|ht)tps?\:\/\//.test(url)) {
    url = 'https://' + url;
  }
  return url;
}

interface IProps {}
const RegistrationReceivedInfo = (props: IProps) => {
  const registrationReceived =
    RegistrationReceivedSelector.useGetRegistrationReceivedDetails();
  let data = _.get(registrationReceived, 'data', {});
  const classes = useStyles();

  return (
    <Card className={classes.card}>
      <div className={classes.row}>
        <p>
          <b>Address Country</b>: {_.get(data, 'address_country', 'Not found')}
        </p>
        <p>
          <b>Address Free</b>: {_.get(data, 'address_free', 'Not found')}
        </p>
        <p>
          <b>Application Type</b>:{' '}
          {_.get(data, 'application_type', 'Not found')}
        </p>
        <p>
          <b>Bank Account</b>: {_.get(data, 'bank_account', 'Not found')}
        </p>
        <p>
          <b>Bank BIC</b>: {_.get(data, 'bank_bic', 'Not found')}
        </p>
        <p>
          <b>Bank IBAN</b>: {_.get(data, 'bank_iban', 'Not found')}
        </p>
        <p>
          <b>Change Date</b>:{' '}
          {_.get(data, 'change_date', false)
            ? DatesUtils.formatDateTimeSeconds(
                _.get(data, 'change_date', 'Not found')
              )
            : 'Not Found'}
        </p>
        <p>
          <b>Commencement Date</b>:{' '}
          {_.get(data, 'commencement_date', false)
            ? DatesUtils.formatDate(
                _.get(data, 'commencement_date', 'Not found')
              )
            : 'Not Found'}
        </p>
        <p>
          <b>Company Name</b>: {_.get(data, 'company_name', 'Not found')}
        </p>
        <p>
          <b>Contact Name Free</b>:{' '}
          {_.get(data, 'contact_name_free', 'Not found')}
        </p>
        <p>
          <b>Country of Business</b>:{' '}
          {_.get(data, 'country_of_business', 'Not found')}
        </p>
        <p>
          <b>Created At</b>:{' '}
          {_.get(data, 'created_at', false)
            ? DatesUtils.formatDateTime(_.get(data, 'created_at', 'Not found'))
            : 'Not Found'}
        </p>
        <p>
          <b>Electronic Interface</b>:{' '}
          {_.get(data, 'electronic_interface', false) ? 'Yes' : 'No'}
        </p>
        <p>
          <b>Email</b>: {_.get(data, 'email', 'Not found')}
        </p>
        <p>
          <b>Message ID</b>: {_.get(data, 'message_id', 'Not found')}
        </p>
        <p>
          <b>MSID Country</b>: {_.get(data, 'msid_country', 'Not found')}
        </p>
        <p>
          <b>Not Established</b>:{' '}
          {_.get(data, 'not_established', false) ? 'Yes' : 'No'}
        </p>
      </div>
      <div className={classes.row}>
        {/* <p>
          <b>Message Timestamp</b>:{' '}
          {_.get(data, 'message_timestamp', false)
            ? DatesUtils.formatDateTime(
                _.get(data, 'message_timestamp', 'Not found').split('Z')[0]
              )
            : 'Not Found'}
        </p> */}
        <p>
          <b>Other MSNETP</b>:{' '}
          {_.get(data, 'other_msnetp', false) ? 'Yes' : 'No'}
        </p>
        <p>
          <b>Previous Registrations</b>:{' '}
          {_.get(data, 'previous_registrations', false) ? 'Yes' : 'No'}
        </p>
        <p>
          <b>Registration Date</b>:{' '}
          {_.get(data, 'registration_date', false)
            ? DatesUtils.formatDate(
                _.get(data, 'registration_date', 'Not found')
              )
            : 'Not Found'}
        </p>
        <p>
          <b>Registration Received ID</b>:{' '}
          {_.get(data, 'registration_received_id', 'Not found')}
        </p>
        <p>
          <b>Request Date</b>:{' '}
          {_.get(data, 'request_date', false)
            ? DatesUtils.formatDate(_.get(data, 'request_date', 'Not found'))
            : 'Not Found'}
        </p>
        <p>
          <b>Telephone</b>: {_.get(data, 'telephone', 'Not found')}
        </p>
        <p>
          <b>Trading Names</b>:{' '}
          {_.get(data, 'trading_names', false)
            ? _.get(data, 'trading_names', '').replace(/,/g, ', ')
            : 'Not Found'}
        </p>
        <p>
          <b>VAT Group</b>: {_.get(data, 'vat_group', false) ? 'Yes' : 'No'}
        </p>
        <p>
          <b>VAT Number</b>: {_.get(data, 'vat_number', 'Not found')}
        </p>
        <p>
          <b>VAT Number Intermediary</b>:
          {_.get(data, 'vat_number_int', 'Not found')}
        </p>
        <p>
          <b>Exclusion Reason</b>: {_.get(data, 'exclusion_code', 'Not found')}
        </p>
        <p>
          <b>Exclusion Decision Date</b>:{' '}
          {_.get(data, 'exclusion_decision_date', false)
            ? DatesUtils.formatDate(
                _.get(data, 'exclusion_decision_date', 'Not found')
              )
            : 'Not Found'}
        </p>
        <p>
          <b>Exclusion Effective Date</b>:{' '}
          {_.get(data, 'exclusion_effective_date', false)
            ? DatesUtils.formatDate(
                _.get(data, 'exclusion_effective_date', 'Not found')
              )
            : 'Not Found'}
        </p>
        <p>
          <b>Importation Effective Date</b>:{' '}
          {_.get(data, 'importation_effective_date', false)
            ? DatesUtils.formatDate(
                _.get(data, 'importation_effective_date', 'Not found')
              )
            : 'Not Found'}
        </p>
        <p>
          <b>Websites</b>:{' '}
          {_.get(data, 'websites', false)
            ? (_.get(data, 'websites', '') as string)
                .split(' ')
                .map((url, i) => (
                  <span key={i}>
                    <br />
                    <a href={addhttps(url)} target="_blank">
                      {url}
                    </a>{' '}
                  </span>
                ))
            : 'Not Found'}
        </p>
        {_.get(data, 'websites', false) &&
          _.get(data, 'has_more_websites', false) && (
            <p>
              {_.get(data, 'has_more_websites', false)
                ? 'This is a partial list of the available websites. For the complete list please check the XML.'
                : 'Above is the complete list of the available websites.'}
            </p>
          )}
        <p>
          <b>National Tax Reference</b>:{' '}
          {_.get(data, 'national_tax_reference') ?? 'Not found'}
        </p>
        <p>
          <b>VAT Identification Number</b>:{' '}
          {_.get(data, 'vat_identification_number') ?? 'Not found'}
        </p>
      </div>
    </Card>
  );
};

export default RegistrationReceivedInfo;
